import { createAction, props } from '@ngrx/store';

export const selectMenu = createAction(
  'selectMenu',
  props<{ selectedMenu: string }>()
);
